@if (mode() === FiscalMode.Training) {
  <div class="training-banner" role="status" aria-live="polite" id="training-mode-banner">
    <nz-icon nzType="experiment" nzTheme="outline"></nz-icon>
    <span class="training-banner__title">MODE FORMATION</span>
    <span class="training-banner__detail">
      Les tickets émis sont sans valeur fiscale et n'entrent pas dans le chiffre d'affaires.
    </span>
  </div>
}
